import { HStack, Select, Spinner } from '@chakra-ui/react';

import { usePatchPerson } from '@services/query-services/people.query-service';
import { useTimeZones } from '@services/query-services/types.query-service';
import { useUserStore } from '@store/app.store';
import { useMutationToast } from '@util/hooks';
import { FORA_TIMEZONE_MAP } from '@util/constants';

export default function TimezoneSection() {
  const user = useUserStore((state) => state?.user);
  const setUser = useUserStore((state) => state?.setUser);
  const { data: timeZones } = useTimeZones();
  const { mutateAsync: patchPerson, isLoading: isChangingTimezone } = usePatchPerson();
  const { onSuccess: onTimezoneChangeSuccess, onError: onTimezoneChangeError } = useMutationToast({
    success: {
      title: 'Successfully Updated User Timezone',
      callback: setUser
    },
    error: { title: 'Something went wrong while updating your timezone. Please try again. ' }
  });

  const onTimezoneChange = async (e) => {
    await patchPerson(
      {
        id: user?.id,
        time_zone_id: e?.target?.value
      },
      {
        onSuccess: onTimezoneChangeSuccess,
        onError: onTimezoneChangeError
      }
    );
  };

  return (
    <HStack gap={4}>
      <Select
        placeholder='Select timezone'
        variant='reskinFilled'
        size='reskinLg'
        isDisabled={isChangingTimezone}
        value={user?.time_zone_id}
        onChange={onTimezoneChange}
      >
        {timeZones?.length &&
          timeZones?.map((tz) => (
            <option
              key={tz.id}
              value={tz.id}
            >
              {tz.name} ({FORA_TIMEZONE_MAP[tz.id] ?? tz.id})
            </option>
          ))}
      </Select>
      {isChangingTimezone && (
        <Spinner
          size='xs'
          color='brandPrimary.primary'
        />
      )}
    </HStack>
  );
}
